import {api} from "api";
import {State} from "./types";
import {close} from "../modal";
import {showAlert} from "../alert";
import {toggleButtonLoaderId} from "../layout";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {thunkBadRequest} from "global/thunk-error";
import {setRequestStatus} from "../request-status";
import {clearClients, setPagination, setClientsSliceRequestStatus} from ".";
import {
  BaseModel,
  Pagination,
  ClientModel,
  ClientProductModel,
} from "interfaces";

export const get = createAsyncThunk(
  "clients/get",
  async (pagination: Pagination, {dispatch, rejectWithValue}) => {
    const {refresh = false, pos, lim, ser, hasMore} = pagination;
    dispatch(setPagination({pos, lim, ser, hasMore}));
    if (refresh) {
      dispatch(
        setClientsSliceRequestStatus({
          name: "clients",
          status: setRequestStatus("initial"),
        })
      );
    }

    try {
      const data = (
        await api.Get<{
          rows: ClientModel[];
          count: number;
        }>(`/clientes/getAll?position=${pos}&limit=${lim}&search=${ser}`)
      )["data"];
      return {data, refresh};
    } catch (error) {
      thunkBadRequest(dispatch, error);
      return rejectWithValue(error);
    }
  }
);

export const getById = createAsyncThunk(
  "clients/get-by-id",
  async (clientId: string, {dispatch, rejectWithValue}) => {
    try {
      return await api.Get<ClientModel>(`/clientes/getById?id=${clientId}`);
    } catch (error) {
      thunkBadRequest(dispatch, error);
      return rejectWithValue(error);
    }
  }
);

export const getClientProducts = createAsyncThunk(
  "clients/get-client-products",
  async (
    pagination: State["clientProductsPagination"],
    {dispatch, rejectWithValue}
  ) => {
    dispatch(setPagination(pagination));
    const {pos, refresh, lim, ser, clientId} = pagination;
    if (refresh) {
      dispatch(
        setClientsSliceRequestStatus({
          name: "clientProducts",
          status: setRequestStatus("initial"),
        })
      );
      dispatch(clearClients());
    }
    try {
      return await api.Get<{
        count: number;
        rows: ClientProductModel[];
      }>(
        `/productos/getAll?position=${pos}&limit=${lim}&search=${ser}&categoria_id=&cliente_id=${clientId}`
      );
    } catch (error) {
      thunkBadRequest(dispatch, error);
      return rejectWithValue(error);
    }
  }
);

export const removeClientProduct = createAsyncThunk(
  "clients/remove-client-product",
  async (id: BaseModel["id"], {dispatch, rejectWithValue}) => {
    dispatch(toggleButtonLoaderId("remove-client-product"));
    try {
      await api.Post<ClientProductModel>("/productos/delete", {id});
      dispatch(close());
      dispatch(
        showAlert({type: "success", title: "Se ha eliminado con éxito"})
      );
      return id;
    } catch (error) {
      thunkBadRequest(dispatch, error);
      return rejectWithValue(error);
    } finally {
      dispatch(toggleButtonLoaderId("remove-client-product"));
    }
  }
);
